// import api from "../../index";
import http from "../../http-common";

const API_URL = process.env.VUE_APP_API_URL || 'localhost:3000';

export default {
  deleteRevision(id) {
    return http.post('api/postulaciones/revisionPostulaciones', { id });
  },
  post(data) {
    const config = data.headers ? { headers: data.headers } : {};
    return http.post(`${API_URL}/${data.route}`, data.params, config);
  },

  get(data) {
    return http.get(`${API_URL}/${data.route}`);
  },

  show(data) {
    return http.get(`${API_URL}/${data.route}/${data.params.id}`);
  },
  showPostulateJurado(data) {
    return http.get(`${API_URL}/${data.route}/${data.params.id}?isJurado=${true}`);
  },
  deleteEvaluation({ evaluationId }) {
    return http.delete(`${API_URL}/api/projects/evaluations/${evaluationId}`);
  },
};